export default __webpack_public_path__ + "static/media/2-reducao-custos.14e41494.svg";